if (!customElements.get('media-footer-block')) {
  class MediaFooterBlock extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('.js-media-footer-toggle');
      if (!this.toggle) return;

      this.toggle.addEventListener('click', this.handleToggle.bind(this));
      this.resizeHandler = this.checkOverflow.bind(this);
      window.addEventListener('on:debounced-resize', this.resizeHandler);
      this.checkOverflow();
    }

    disconnectedCallback() {
      window.removeEventListener('on:debounced-resize', this.resizeHandler);
    }

    /**
     * Toggles the expanded state of the footer block.
     */
    handleToggle() {
      const expanded = this.classList.toggle('is-expanded');
      this.toggle.setAttribute('aria-expanded', expanded);
    }

    /**
     * Shows the expand icon only when the heading or text is actually
     * clamped. Skipped while expanded so that a resize firing right after
     * a tap (e.g. the address bar collapsing on mobile Safari) doesn't
     * immediately re-collapse content the visitor just opened.
     */
    checkOverflow() {
      if (this.classList.contains('is-expanded')) return;

      const heading = this.querySelector('.media-gallery__footer-heading');
      const text = this.querySelector('.media-gallery__footer-text');
      const isClamped = (el) => !!el && el.scrollHeight > el.clientHeight + 1;

      this.classList.toggle('has-overflow', isClamped(heading) || isClamped(text));
    }
  }

  customElements.define('media-footer-block', MediaFooterBlock);
}
